import createToolbar from './toolbar/createToolbar.js';
import { mergeStyles } from 'wix-rich-content-common';
import { createBasePlugin, PLUGIN_DECORATION_PROPS, PLUGIN_DECORATIONS } from 'wix-rich-content-plugin-commons';
import { LINK_BUTTON_TYPE, ACTION_BUTTON_TYPE } from './types.js';
import { DEFAULTS } from './defaults.js';
import { S as Styles } from './default-styles-74c82233.js';
import ButtonComponent from './button-component.js';
import { isNumber } from 'lodash';
import './toolbar/inline-buttons.js';
import 'wix-rich-content-editor-common';
import './modals.js';
import './toolbar/buttonInputModal.js';
import 'prop-types';
import 'react';
import 'react-custom-scrollbars';
import 'wix-rich-content-ui-components';
import './components/design-component.js';
import './components/color-toggle-component.js';
import 'classnames';
import './style-inject.es-746bb8ed.js';
import './constants.js';
import 'ricos-schema';
import './components/settings-component.js';
import './components/preview-component.js';
import './viewer/button-viewer.js';
import 'ricos-context';
import './toolbar/insert-buttons.js';
import './icons/InsertPluginIcon.js';
import './classNameStrategies.js';
import './components/button-viewer.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createLinkButtonPlugin = (config) => {
  return createButtonPlugin(LINK_BUTTON_TYPE, config);
};
const createActionButtonPlugin = (config) => {
  return createButtonPlugin(ACTION_BUTTON_TYPE, config);
};
const createButtonPlugin = (type, config) => {
  const _a = config, {
    helpers,
    theme,
    themeData,
    t,
    anchorTarget,
    relValue,
    isMobile,
    [type]: settings = {}
  } = _a, rest = __objRest(_a, [
    "helpers",
    "theme",
    "themeData",
    "t",
    "anchorTarget",
    "relValue",
    "isMobile",
    __restKey(type)
  ]);
  const isLinkButton = type === LINK_BUTTON_TYPE;
  settings.isActionButton = !isLinkButton;
  settings.themeData = themeData;
  const styles = mergeStyles({ styles: Styles, theme });
  const customTooltip = settings.insertButtonTooltip;
  return createBasePlugin(__spreadValues({
    component: ButtonComponent,
    settings,
    theme,
    themeData,
    type,
    anchorTarget,
    relValue,
    toolbar: createToolbar({
      settings,
      helpers,
      styles,
      t,
      isMobile,
      customTooltip,
      relValue,
      anchorTarget,
      type
    }),
    helpers,
    t,
    defaultPluginData: DEFAULTS,
    isMobile,
    pluginDecorationProps: (props, componentData) => {
      var _a2;
      const width = (_a2 = componentData.config) == null ? void 0 : _a2.width;
      let calulatedProps = props;
      if (!isNumber(width)) {
        calulatedProps = __spreadProps(__spreadValues({}, props), {
          width,
          style: __spreadProps(__spreadValues({}, props.style), {
            width
          })
        });
      }
      return PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](calulatedProps);
    },
    componentWillReceiveDecorationProps: (props, nextProps, onPropsChange) => {
      const { width } = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](props);
      const { width: nextWidth } = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](nextProps);
      if (width !== nextWidth) {
        onPropsChange({ width: nextWidth, size: "inline" });
      }
    }
  }, rest));
};
createButtonPlugin.functionName = "wix-rich-content-plugin-button";

export { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE, createActionButtonPlugin, createLinkButtonPlugin };
//# sourceMappingURL=createButtonPlugin.js.map
